import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

export const Route = createFileRoute("/(auth)/login")({
  validateSearch: z.object({
    email: z.string().optional(),
    redirect: z.string().optional(),
    // Logging in with one more account while another stays logged in
    addAccount: z.boolean().optional(),
  }),
})
